export default __webpack_public_path__ + "static/media/ARROW-F.66e6f348.svg";